const LOGO = (file) => `/images/brokers/${file}`;

export const BROKERS = [
  {
    id: "aj-bell",
    name: "AJ Bell",
    logo: LOGO("aj-bell.avif"),
    description:
      "AJ Bell is a British public limited company that provides online investment platforms and stockbroking services.",
  },
  {
    id: "alpaca",
    name: "Alpaca",
    logo: LOGO("alpaca.avif"),
    description: "Alpaca is a commission-free API-first brokerage servicing the USA and beyond.",
    featured: true,
  },
  {
    id: "binance",
    name: "Binance",
    logo: LOGO("binance.avif"),
    description: "Binance Holdings Ltd., branded as Binance, is a global company operating one of the world's largest cryptocurrency exchanges.",
  },
  {
    id: "bmo",
    name: "BMO InvestorLine",
    shortName: "BMO",
    logo: LOGO("bmo.avif"),
    description:
      "BMO InvestorLine Self-Directed is a Canadian online investing platform for independently minded investors.",
    featured: true,
  },
  {
    id: "bux",
    name: "BUX",
    logo: LOGO("bux.avif"),
    description: "BUX is an online brokerage, headquartered in Amsterdam, the Netherlands.",
  },
  {
    id: "chase",
    name: "Chase",
    logo: LOGO("chase.avif"),
    description:
      "JPMorgan Chase Bank, N.A., doing business as Chase, is an American national bank headquartered in New York.",
    featured: true,
  },
  {
    id: "cibc",
    name: "CIBC Investor's Edge",
    shortName: "CIBC",
    logo: LOGO("cibc.avif"),
    description:
      "CIBC Investor’s Edge is a Canadian self-directed investing platform that lets clients manage their own portfolios.",
    featured: true,
  },
  {
    id: "citi",
    name: "Citi",
    logo: LOGO("citi.avif"),
    description:
      "Citi offers self-directed investing through Citi Self Invest, giving clients a way to build and manage their own portfolios.",
  },
  {
    id: "coinbase",
    name: "Coinbase",
    logo: LOGO("coinbase.avif"),
    description:
      "Coinbase is the largest cryptocurrency exchange in the United States in terms of trading volume.",
    featured: true,
  },
  {
    id: "commsec",
    name: "CommSec",
    logo: LOGO("commsec.avif"),
    description:
      "Commonwealth Securities Limited, or CommSec, is Australia's largest online stockbroking firm.",
  },
  {
    id: "degiro",
    name: "DEGIRO",
    logo: LOGO("degiro.avif"),
    description:
      "DEGIRO is one of Europe's fastest growing online stock brokers, distinguishing itself with low-cost access to global markets.",
    fit: "cover",
  },
  {
    id: "etrade",
    name: "E*TRADE",
    logo: LOGO("etrade.avif"),
    description:
      "E*TRADE Financial Corporation is a financial services company, headquartered in Arlington, Virginia.",
    featured: true,
  },
  {
    id: "edward-jones",
    name: "Edward Jones",
    logo: LOGO("edward-jones.avif"),
    description:
      "Edward Jones offers investment accounts for individuals who want to build, manage, and diversify their portfolios.",
  },
  {
    id: "empower",
    name: "Empower",
    logo: LOGO("empower.avif"),
    description:
      "Empower Annuity Insurance Company of America is a retirement plan record-keeping financial services company.",
  },
  {
    id: "etoro",
    name: "eToro",
    logo: LOGO("etoro.avif"),
    description:
      "eToro Group Ltd. is a multi-asset investment and social trading company focused on providing access to global markets.",
    featured: true,
  },
  {
    id: "fidelity",
    name: "Fidelity",
    logo: LOGO("fidelity.svg"),
    description:
      "Headquartered in Boston, Fidelity serves its customers through 216 Investor Centers in the United States.",
    featured: true,
    bleed: true,
  },
  {
    id: "interactive-brokers",
    name: "Interactive Brokers",
    shortName: "IBKR",
    logo: LOGO("interactive-brokers.avif"),
    description:
      "Interactive Brokers, Inc., headquartered in Greenwich, Connecticut, is an American multinational brokerage firm.",
    featured: true,
  },
  {
    id: "kraken",
    name: "Kraken",
    logo: LOGO("kraken.avif"),
    description: "Kraken is a United States–based cryptocurrency exchange, founded in 2011.",
    featured: true,
  },
  {
    id: "moomoo",
    name: "Moomoo",
    logo: LOGO("moomoo.avif"),
    description:
      "Moomoo is a global investment and trading platform, owned by Futu, a Hong Kong–headquartered financial technology company.",
    featured: true,
  },
  {
    id: "pnc",
    name: "PNC",
    logo: LOGO("pnc.avif"),
    description:
      "PNC Wealth Management offers brokerage accounts for investors who want to build, manage, and grow their portfolios.",
  },
  {
    id: "public",
    name: "Public",
    logo: LOGO("public.svg"),
    description:
      "Public is an investing platform that offers fractional investing in stocks, exchange-traded funds, and other assets.",
    featured: true,
    bleed: true,
  },
  {
    id: "questrade",
    name: "Questrade",
    logo: LOGO("questrade.avif"),
    description:
      "Questrade is an online brokerage firm and wealth management firm, headquartered in Toronto.",
    featured: true,
  },
  {
    id: "robinhood",
    name: "Robinhood",
    logo: LOGO("robinhood.svg"),
    description:
      "Robinhood Markets, Inc. is an American financial services company headquartered in Menlo Park, California.",
    featured: true,
    bleed: true,
  },
  {
    id: "schwab",
    name: "Schwab",
    logo: LOGO("schwab.svg"),
    description:
      "The Charles Schwab Corporation is an American multinational financial services company.",
    featured: true,
    bleed: true,
  },
  {
    id: "stake-aus",
    name: "Stake AUS",
    logo: LOGO("stake.svg"),
    description:
      "Stake AUS is the Australian arm of Stake, an investing platform headquartered in Sydney, Australia.",
    bleed: true,
  },
  {
    id: "tastytrade",
    name: "tastytrade",
    logo: LOGO("tastytrade.avif"),
    description:
      "Open a trading account and start trading options, stocks, and futures at one of the top trading platforms for active investors.",
    featured: true,
    fit: "cover",
  },
  {
    id: "td",
    name: "TD Direct Investing",
    shortName: "TD",
    logo: LOGO("td.avif"),
    description:
      "TD Direct Investing is Canada's top digital brokerage, offering tools, resources, and analysis for self-directed investors.",
    featured: true,
  },
  {
    id: "tiaa",
    name: "TIAA",
    logo: LOGO("tiaa.avif"),
    description:
      "TIAA Brokerage gives investors a self-directed way to build and manage their own portfolios.",
  },
  {
    id: "tradestation",
    name: "TradeStation",
    logo: LOGO("tradestation.svg"),
    description:
      "TradeStation offers trading and brokerage solutions for sophisticated traders, headquartered in Plantation, Florida.",
    featured: true,
  },
  {
    id: "tradier",
    name: "Tradier",
    logo: LOGO("tradier.svg"),
    description:
      "Tradier is a full-featured, customizable trading platform, headquartered in Charlotte, North Carolina.",
    bleed: true,
  },
  {
    id: "trading212",
    name: "Trading 212",
    logo: LOGO("trading212.avif"),
    description: "Trading 212 is an online brokerage, headquartered in Amsterdam, the Netherlands.",
  },
  {
    id: "transamerica",
    name: "Transamerica",
    logo: LOGO("transamerica.avif"),
    description:
      "Transamerica offers investment and brokerage services through Transamerica Financial Advisors.",
  },
  {
    id: "upstox",
    name: "Upstox",
    logo: LOGO("upstox.svg"),
    description: "Upstox is an online brokerage, headquartered in Mumbai, India.",
    bleed: true,
  },
  {
    id: "us-bank",
    name: "U.S. Bank",
    logo: LOGO("us-bank.avif"),
    description:
      "U.S. Bancorp Advisors offers online investing options for clients who want to build and manage their portfolios.",
  },
  {
    id: "vanguard",
    name: "Vanguard US",
    shortName: "Vanguard",
    logo: LOGO("vanguard.svg"),
    description:
      "Vanguard is one of the world's largest investment companies, headquartered in Malvern, Pennsylvania.",
    featured: true,
    bleed: true,
  },
  {
    id: "wealthsimple",
    name: "Wealthsimple",
    logo: LOGO("wealthsimple.avif"),
    description:
      "Wealthsimple Trade is a brokerage to buy and sell stocks and ETFs with no trading commissions.",
    featured: true,
  },
  {
    id: "webull-canada",
    name: "Webull Canada",
    logo: LOGO("webull.svg"),
    description:
      "Webull is a commission-free online broker, headquartered in New York City, New York.",
    bleed: true,
  },
  {
    id: "webull-us",
    name: "Webull US",
    shortName: "Webull",
    logo: LOGO("webull.svg"),
    description:
      "Webull is a commission-free online broker, headquartered in New York City, New York.",
    featured: true,
    bleed: true,
  },
  {
    id: "wells-fargo",
    name: "Wells Fargo",
    logo: LOGO("wells-fargo.avif"),
    description:
      "Wells Fargo & Company is an American multinational financial services company with a significant retail banking and brokerage presence.",
  },
  {
    id: "zerodha",
    name: "Zerodha",
    logo: LOGO("zerodha.avif"),
    description: "Zerodha is the largest stock brokerage firm in India, headquartered in Bengaluru, India.",
  },
];

export const FEATURED_BROKERS = BROKERS.filter((broker) => broker.featured);

export const INTEGRATIONS_PATH = "/integrations";
